import React from 'react';
import { ChakraProvider } from "@chakra-ui/react"
import {system} from './theme';
import {ColorModeProvider} from './Components/ui/color-mode'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import Layout from './Components/layout/Layout';
import HeroSection from './Components/sections/HeroSection';
import FeaturesSection from './Components/sections/FeaturesSection';
import HowItWorksSection from './Components/sections/HowItWorksSection';
import UseCasesSection from './Components/sections/UseCasesSection';
import TestimonialsSection from './Components/sections/TestimonialsSection';
import StayUpdatedSection from './Components/sections/StayUpdatedSection';
import SEO from './Components/SEO';
import DIYBuddy from './DIYBuddy/DIYBuddy';
// PostHog automatic tracking is enabled in index.tsx

// Home page component
const HomePage = () => (
  <Layout>
    <HeroSection />
    <FeaturesSection />
    <HowItWorksSection />
    <UseCasesSection />
    {/* <TestimonialsSection /> */}
    <StayUpdatedSection />
  </Layout>
);

// Component with routing
const AppWithRouting = () => {
  // Using PostHog's automatic tracking - no custom hook needed
  return (
    <>
      <SEO />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/app" element={<DIYBuddy />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ChakraProvider value={system}>
        <ColorModeProvider>
          <Router>
            <AppWithRouting />
          </Router>
        </ColorModeProvider>
      </ChakraProvider>
    </HelmetProvider>
  );
}

export default App;
